(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product"]) return;
  try {
    
  (() => {
    const reorder = (scope = document) => {
      scope.querySelectorAll('.broek-merch-grid').forEach((grid) => {
        [...grid.querySelectorAll(':scope > .broek-merch-card')]
          .sort((a, b) => Number.parseInt(a.style.getPropertyValue('--broek-merch-order'), 10) - Number.parseInt(b.style.getPropertyValue('--broek-merch-order'), 10))
          .forEach((card) => grid.append(card));
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => reorder(), { once: true });
    } else {
      reorder();
    }
    document.addEventListener('shopify:section:load', (event) => reorder(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subcollection-list"]) return;
  try {
    
  (() => {
    const init = () => {
      const nav = document.querySelector('[data-broek-top-categories]');
      if (!nav || nav.dataset.broekReady === '1') return;
      nav.dataset.broekReady = '1';
      let active = 'all';
      const wrap = nav.closest('[data-broek-top-categories-wrap]');
      const status = wrap?.querySelector('[data-broek-top-filter-status]');

      const updateOverflow = () => {
        if (!wrap) return;
        const hasOverflow = nav.scrollWidth > nav.clientWidth + 2;
        const atEnd = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 4;
        wrap.classList.toggle('has-overflow', hasOverflow);
        wrap.classList.toggle('is-at-end', atEnd);
      };

      const apply = (key) => {
        active = key;
        let visibleCount = 0;
        nav.querySelectorAll('[data-broek-top-filter]').forEach((button) => {
          const selected = button.dataset.broekTopFilter === key;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-pressed', String(selected));
          button.tabIndex = selected ? 0 : -1;
        });
        document.querySelectorAll('[data-broek-gift-category]').forEach((card) => {
          const matches = key === 'all'
            || key === 'best' && card.dataset.broekBestSeller === 'true'
            || card.dataset.broekGiftCategory === key;
          card.hidden = !matches;
          if (matches) visibleCount += 1;
        });
        const amount = document.querySelector('.broek-gift-collection-main .toolbar-amount');
        if (amount) amount.textContent = `${visibleCount} eligible ${visibleCount === 1 ? 'top' : 'tops'} shown`;
        if (status) status.textContent = `${visibleCount} eligible ${visibleCount === 1 ? 'top' : 'tops'} shown`;
      };

      nav.addEventListener('click', (event) => {
        const button = event.target.closest('[data-broek-top-filter]');
        if (!button || !nav.contains(button)) return;
        apply(button.dataset.broekTopFilter || 'all');
        button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });

      nav.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const buttons = [...nav.querySelectorAll('[data-broek-top-filter]')];
        const current = Math.max(0, buttons.indexOf(document.activeElement));
        const next = event.key === 'Home' ? 0
          : event.key === 'End' ? buttons.length - 1
          : (current + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        event.preventDefault();
        buttons[next]?.focus();
        buttons[next]?.click();
      });

      nav.addEventListener('scroll', updateOverflow, { passive: true });
      window.addEventListener('resize', updateOverflow, { passive: true });

      const grid = document.getElementById('product-grid');
      if (grid) {
        new MutationObserver(() => apply(active)).observe(grid, { childList: true });
      }
      apply('all');
      requestAnimationFrame(updateOverflow);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();
})();
